import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5887ddac&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5887ddac')) {
      api.createRecord('5887ddac', component.options)
    } else {
      api.reload('5887ddac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5887ddac&", function () {
      api.rerender('5887ddac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/md-custom-code/federated/index.vue"
export default component.exports